<template lang="pug">
  div
    collection-profile.my-4(:loyaltySystem="loyaltySystem" :member-id="profile.id" :name="profile.name" :phone="profile.phone" :email="profile.email" :totalSpend="profile.total_spend" :valueCollected="profile.collected")
    v-divider.my-4
    redeem-reward-list-item(:value="value" :loyaltySystem="loyaltySystem" :collected-value="profile.collected" :available-rewards="profile.available_rewards" @input="$emit('input', $event)")
</template>

<script>

import CollectionProfile from "@/components/marketing/merchantapp/collect/CollectionProfile.vue";
import RedeemRewardListItem from "@/components/marketing/merchantapp/redeem/RedeemRewardListItem.vue";

export default {
  components: {
    RedeemRewardListItem,
    CollectionProfile,
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
}
</script>

<style scoped>
</style>
